<template>
  <div class="rysbsp">
    <div class="u-text-center">
      <car-form
        @submit="submit"
        :showformitem="[
          'personName',
          'personIdcard',
          'personType',
          'checkStatus',
          'passType'
        ]"
      ></car-form>
    </div>
    <div class="u-position-relative u-h-100">
      <hy-data-table
        v-model="loading"
        height="94%"
        ref="dataTable"
        @find-page="findPage"
        @detail-handle="detailHandle"
        @del="del"
        is-all-handle
        :data="dataTable.list"
        :columns="dataTable.columns"
        :extend-buttons="dataTable.buttons"
        :show-batch-delete="false"
        :show-operation="true"
        size="medium"
        :paging="dataTable.paging"
        :extend-but-widht="130"
      ></hy-data-table>
    </div>
  </div>
</template>

<script>
import carForm from '@/components/form/carForm.vue';
import hyDataTable from '@/components/HyDataTable.vue';
import { mapState } from 'vuex';

export default {
  components: {
    carForm,
    hyDataTable
  },
  data() {
    return {
      saveAddTemplate: {},

      apiUrl: {
        imgUploadApi: this.$apis.POST_hyPersonUploadImg,
        delApi: 'GET_hyPersonDelete',
        addApi: 'POST_hyPersonAdd',
        detailApi: 'GET_hyPersonFind',
        updateApi: 'POST_hyPersonUpdate',
        approvalApi: 'POST_hyPersonVerifyPerson',
        indexApi: 'POST_hyPersonIndex'
      },
      sortName: [
        '姓名',
        '工作地址',
        '身份证号',
        '申报理由',
        '性别',
        '申报来源',
        '年龄',
        '通行时间范围',
        '人员类型',
        '有效期范围',
        '人脸图片',
        '通行类型',
        '申请人企业',
        '创建时间',
        '联系电话',
        '人员状态',
        '审批状态',
        '审批意见',
        '审批时间',
        '审批人'
      ],
      form: {},
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: 'personName', label: '姓名', minWidth: 80 },
          { prop: 'personIdcard', label: '身份证号', minWidth: 120 },
          { prop: 'passTime', label: '通行时间范围', minWidth: 120 },
          { prop: 'validityPeriodTime', label: '有效期限', minWidth: 120 },
          { prop: 'personType', label: '人员类型', minWidth: 100 },
          { prop: 'personCompany', label: '申请企业', minWidth: 180 },
          { prop: 'telphone', label: '联系电话', minWidth: 100 },
          { prop: 'passType', label: '通行类型', minWidth: 100 },
          { prop: 'personStatus', label: '人员状态', minWidth: 70 },
          { prop: 'checkStatus', label: '审批状态', minWidth: 70 }
        ],
        buttons: [
          {
            label: '详情',
            click: 'detail-handle',
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: 'primary'
          },
          {
            label: '删除',
            click: 'del',
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: 'error'
          }
        ],
        paging: {
          pageIndex: 1 // 表格分页信息
        }
      }
    };
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh
    })
  },
  methods: {
    submit(form) {
      this.form = form;
      // this.form = {
      //   checkStatus: form.checkStatus,
      //   coEin: form.coEin,
      //   coName: form.coName
      // };
      this.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      console.log('findPage');
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    add() {
      const data = this.saveAddTemplate;

      this.$store.commit('boxDetail', {
        data: data,
        title: '新增',
        api: this.apiUrl.addApi,
        uploadImgApi: this.apiUrl.imgUploadApi,
        sort: this.sortName
      });
    },
    detailHandle(res) {
      const data = res.row;
      const id = data.id || data.personNo;
      this.$http[this.apiUrl.detailApi]({ paramsID: id }).then((response) => {
        if (response.data)
          this.$store.commit('boxDetail', {
            data: response.data,
            title: '详情',
            api: this.apiUrl.updateApi,
            approvalApi: this.apiUrl.approvalApi,
            uploadImgApi: this.apiUrl.imgUploadApi,
            sort: this.sortName
          });
      });
    },
    del(res) {
      const id = res.row.id || res.row.personNo;
      this.$http[this.apiUrl.delApi]({ paramsID: id }).then((response) => {
        if ((response.code = '00000')) {
          this.$message.success('删除成功');
          if (this.dataTable.list.data.length === 1)
            this.pageIndex = this.pageIndex - 1;
          this.getData();
        } else {
          this.$message.error('删除失败:' + response.msg);
        }
      });
    },
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      let arr = [];
      this.$http[this.apiUrl.indexApi](this.form)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              let result = this.$myPlug.sortName2cn(response.data[i]);
              result.validityPeriodTime = result.validityPeriodStart
                ? result.validityPeriodStart + '至' + result.validityPeriodEnd
                : '';

              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: []
          };
          this.$set(this.dataTable.list, 'data', arr);
          this.saveAddTemplate = JSON.parse(
            JSON.stringify(this.dataTable.list.data[0])
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  created() {
    this.getData();
  },
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/sbgl/rysbsp.vue